import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const DoubleArrowUpIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        fill={theme.colors.primary.variant1}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.062 16 5 14.938l5-5 5 5L13.938 16 10 12.062Zm0-5.938L5 9l5-5 5 5-1.062 1.062L10 6.125Z" />
      </svg>
    </Icon>
  );
};

export default DoubleArrowUpIcon;
